/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_gui.js                                                               */
/**********************************************************************************************************************/
/* Controller GUI */
HafasWebapp.prototype.Controller.GUI = {
  jumpBackTarget: null, // Wird fuer den Ruecksprung in einen anderen Context verwendet. (Wenn Ergebnis geschlossen wird)
  pageHeaderHeight: 50,
  pageHeaderHeightXL: 190,
  goBack: function () {
    window.history.back();
  },
  resize: function (params) {
    params = params || { windowResize: false };

    // Beobachte die Breitenaenderung von this.webappWrap
    var $webappWrap = Hafas('#' + this.webappWrap, false),
      webAppW = window.innerWidth;

    if (!Hafas.Config.Switches.useMediaQueries) {
      webAppW = $webappWrap.offsetWidth;
    }

    // aktuelle LayoutClass ermitteln
    var currLayoutClass = $webappWrap.className.match(/(layout-)([a-zA-Z]*)/g);
    var bodylayoutClass = document.body.className;
    if (currLayoutClass) {
      currLayoutClass = currLayoutClass[0].split('-')[1];
    } else {
      currLayoutClass = '';
      bodylayoutClass = '';
    }

    // Zuruecksetzen der Layout Class
    var _className = (Hafas.Config.forceLayoutClass) ? 'lyr_wrapApplication forcedLayout' : 'lyr_wrapApplication no-forcedLayout';
    $webappWrap.className = _className;
    document.body.className = '';

    var tmpLayoutClass = this.layoutClass;

    // Setzen der Layout Class
    // Wenn forceLayoutClass == true, wird die WebApp nur in der deklarierten layout-Klasse betrieben
    if (Hafas.Config.forceLayoutClass) {
      $webappWrap.addClassName('layout-' + Hafas.Config.layoutClass);
      this.layoutClass = Hafas.Config.layoutClass;
      $webappWrap.addClassName('js-map-as-single-view');

      switch (true) {
        case webAppW > Hafas.Config.layoutClassMinWidths.xLarge:
          $webappWrap.addClassName('mq-xlarge');
          break;
        case webAppW > Hafas.Config.layoutClassMinWidths.large:
          $webappWrap.addClassName('mq-large');
          break;
        case webAppW > Hafas.Config.layoutClassMinWidths.mid:
          $webappWrap.addClassName('mq-mid');
          break;
        case webAppW > Hafas.Config.layoutClassMinWidths.small:
          $webappWrap.addClassName('mq-small');
          document.body.addClassName('mq-small');
          break;
      }


    } else {
      switch (true) {
        case webAppW > Hafas.Config.layoutClassMinWidths.xLarge:
          $webappWrap.addClassName('layout-xlarge');
          this.layoutClass = 'xlarge';
          break;
        case webAppW > Hafas.Config.layoutClassMinWidths.large:
          $webappWrap.addClassName('layout-large');
          this.layoutClass = 'large';
          break;
        case webAppW > Hafas.Config.layoutClassMinWidths.mid:
          $webappWrap.addClassName('layout-mid');
          document.body.addClassName('layout-mid');
          this.layoutClass = 'mid';
          break;
        case webAppW > Hafas.Config.layoutClassMinWidths.small:
          $webappWrap.addClassName('layout-small');
          $webappWrap.addClassName('js-map-as-single-view');
          document.body.addClassName('layout-small');
          this.layoutClass = 'small';
          break;
      }
    }

    if (Hafas.Modules.IFrameApi)
      Hafas.Modules.IFrameApi.sendLayoutClassChange(this.layoutClass);

    var isMobile = Hafas.Util.getPlatform().isMobile;

    if(isMobile){
      var appHeight = window.innerHeight;
      document.body.style.height = appHeight + 'px';
      var headerNavItems = Hafas('#HFS_HeaderNav div',true)
      headerNavItems.forEach(function(item){
       item.setAttribute('aria-hidden',true)
      });
    }
  },

  common: {
    /**
     * Diese Funktion leitet einen Klick an den Button mit dem ersten angegebenen selector weiter.
     * Außerdem muss der gefundene Button vom HTML-Tag `<button>` sein.
     *
     * @method Controller.GUI.common.forwardClick(data)
     * @param data
     *  {String} data.selector = Hafas(selector)
     *  {DOM-Element} data.trigger = this
     *
     */
    atomForwardClick: function (data) {
      if (typeof data === "object") {
        if (typeof data.selector === "string") {
          var forwardClickedButton = Hafas(data.selector, true, data.trigger);
          if (Array.isArray(forwardClickedButton)) {
            forwardClickedButton = forwardClickedButton[0];
          }
          if (typeof forwardClickedButton !== "undefined" &&
            forwardClickedButton !== null &&
            forwardClickedButton.tagName.toLowerCase() === "button") {
            if (forwardClickedButton.hasAttribute('onclick') &&
              typeof forwardClickedButton.click === "function") {
              forwardClickedButton.click();
            } else {
              console.warn('HafasWebapp.prototype.Controller.GUI.common.atomForwardClick: Found element with "data.selector" has not onclick="...".');
            }
          } else {
            console.warn('HafasWebapp.prototype.Controller.GUI.common.atomForwardClick: Found element with "data.selector" is not <button>.');
          }
        } else {
          console.warn('HafasWebapp.prototype.Controller.GUI.common.atomForwardClick: Attribute "data.selector" must be a string.');
        }
      } else {
        console.warn('HafasWebapp.prototype.Controller.GUI.common.atomForwardClick: "data" must be a object.');
      }
    },
    /**
     * Diese Funktion leitet bei einem Key-Event den Druck auf SPACE oder ENTER an den Click-Handler weiter.
     * Wird verwendet, um divs mit role=button wie native Buttons funktionieren zu lassen
     *
     * @method Controller.GUI.common.atomForwardKeyToClick
     * @param {KeyEvent} event Das Event aus dem Key-Handler
     * @param {DOMElement} element Das Element, von dem das Event kommt und an dessen Klick-Handler es weitergeleitet werden soll
     */
    atomForwardKeyToClick: function (event, element) {
      // In FF ist keyCode "0" wenn SPACE gedrückt wird. Stattdessen steht der Code dann in "charCode"
      var code = event.charCode || event.keyCode;
      var codes = Hafas.Util.keycode;

      if (code === codes.ENTER ||
        code === codes.SPACE) {
        event.preventDefault();
        element.click();
      }
    },
    /**
     * Diese Funktion öffnet und schließt (toggle) einen oder mehrere DOM-Container (anhand ARIA-Attribute und hidden-Attribute).
     * Ein DOM-Button `<button>` wird mit dem Attribute "aria-controls" mit DOM-Container (space separiert) verknüpft.
     *
     * Der DOM-Container wird mit `hidden` ausgeblendet und der DOM-Button ein `aria-expanded="true"`.
     * Darstellung des Buttons kann somit mit `[aria-expanded="true"]` oder `[aria-expanded="false"]` beeinflusst werden.
     *
     * Mit der `prevContId` können mehrere Buttons zusammengefügt werden, um somit mehrfach geöffnete Container zu unterbinden.
     * Ohne diese `prevContId` können die Container unabhängig geöffnet werden.
     *
     * @method Controller.GUI.common.atomToggleContainer
     * @param data {Object}
     * data.open = Status der Sichtbarkeit
     * data.surrounding = Blendet benachbarte Container aus oder ein.
     * data.blockFocus = begrenzt Fokus auf den übergebenen Container
     * data.trigger = clickedElement
     * data.prevContId = previousContainerId
     */
    atomToggleContainer: function (data) {
      // Auslösenden Button feststellen, wenn nicht dieser übergeben wurde, sondern der zu schließende Container
      if (!data.hasOwnProperty('trigger') && data.hasOwnProperty('target')) {
        var triggerId = Hafas("#" + data.target).getAttribute('aria-labelledby');
        data.trigger = Hafas("#" + triggerId);
      }
      // console.log("atomToggleContainer", data, this);
      if (!data || !data.trigger) {
        console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: Missing "data.trigger" attribute in onclick-event.');
        return;
      }

      var _me = this;
      var clickedButton = data.trigger;

      if (!(clickedButton.tagName.toLowerCase() === "button" ||
        clickedButton.getAttribute('role') === "button") &&
        !clickedButton.hasAttribute('aria-controls')) {
        console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: Missing "aria-controls" attribute on <button>.');
        return;
      }

      var ariaControls = clickedButton.getAttribute('aria-controls');
      var containerId = '#' + ariaControls;
      var guiCommon = _me.Controller.GUI.common;
      var atomStore = guiCommon.atomStorePreviousToggleButtons;

      // Eventuell möchte man alte Container wieder ausblenden
      if (typeof data.prevContId === "string" &&
        typeof atomStore === "object" &&
        atomStore[data.prevContId] &&
        clickedButton !== atomStore[data.prevContId]) {
        // Eigener Aufruf um alle verknüfte Container auszublenden
        Hafas.ps.pub('/GUI/common/atomToggleContainer', [{
          trigger: atomStore[data.prevContId],
          prevContId: data.prevContId,
          event: data.event
        }]);
        // Lösche Referenz des DOM-Buttons
        atomStore[data.prevContId] = null;
      }

      // Ermittel den Sichtbarkeitsstatus und wende aria-expanded an.
      var newVisibilityStatus = true;
      // übergebener Status ob Sichtbar/Offen oder geschlossen
      if (data.hasOwnProperty('open')) {
        newVisibilityStatus = data.open;
      } else if (clickedButton.getAttribute('aria-expanded') === "false" || !clickedButton.hasAttribute('aria-expanded')) {
        newVisibilityStatus = true;
        // Buttons im Array speichern ab, um alle Container der id zu schließen
        if (data.prevContId) {
          if (typeof data.prevContId === "string") {
            // Erstelle dynamisch die IdListe
            if (typeof atomStore !== "object") {
              guiCommon.atomStorePreviousToggleButtons = {};
            }
            atomStore[data.prevContId] = clickedButton;
          } else {
            console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: Attribute "data.prevContId" must be a string.');
          }
        }
      } else {
        newVisibilityStatus = false;
        if (typeof data.prevContId === "string" &&
          typeof atomStore[data.prevContId] !== "undefined" &&
          atomStore[data.prevContId] !== null) {
          // Alte Container zurücksetzen
          atomStore[data.prevContId] = null;
        }
      }

      clickedButton.setAttribute('aria-expanded', newVisibilityStatus);
      // Genannten Container einblenden
      var containerToToggle = Hafas(containerId);
      if (containerToToggle) {
        // unlockFocus sollte vor dem Ausblenden angewendet werden.
        if (data.hasOwnProperty('blockFocus') && data.blockFocus === true && !newVisibilityStatus) {
          Hafas.Util.gui.dialog.unlockFocus(containerToToggle);
        }
        // Blendet umliegende Container mit aria-hidden aus.
        if (data.hasOwnProperty('surrounding') && data.surrounding === true) {
          if (newVisibilityStatus) {
            Hafas.Util.gui.dialog.hideSurrounding(containerToToggle);
          } else {
            Hafas.Util.gui.dialog.showSurrounding(containerToToggle);
          }
        }
        Hafas.Util.gui.setVisibility(containerToToggle, newVisibilityStatus);

        // Tracking, nur wenn Optionen sichtbar gemacht werden (wegschalten wird nicht getrackt)
        if (newVisibilityStatus === true) {
          if (typeof containerToToggle.id !== 'undefined' && containerToToggle.id === 'HFS_CustomerOptionsWrap') {
            if (containerToToggle.getAttribute('aria-labelledby') === 'HFS_OptionsButtonTP') {
              Hafas.ps.pub('/tracking/screen/connection-options-main', [{
                typ: 'screen',
                key: 'connection-options-main'
              }]);
              Hafas.ps.pub('/tracking/screen/tripplanner-options-main', [{
                typ: 'screen',
                key: 'tripplanner-options-main'
              }]);
              Hafas.ps.pub('/tracking/event/tripplanner-options-pressed', [{
                typ: 'screen',
                key: 'tripplanner-options-pressed'
              }]);
            }
            if (containerToToggle.getAttribute('aria-labelledby') === 'HFS_OptionsButtonSQ') {
              Hafas.ps.pub('/tracking/screen/stationboard-options-main', [{
                typ: 'screen',
                key: 'stationboard-options-main'
              }]);
              Hafas.ps.pub('/tracking/event/stationboard-options-pressed', [{
                typ: 'screen',
                key: 'stationboard-options-pressed'
              }]);
            }
          }
        }

        // Blockt den Fokus auf den Container
        if (data.hasOwnProperty('blockFocus') && data.blockFocus === true && newVisibilityStatus) {
          Hafas.Util.gui.dialog.blockFocus(containerToToggle);
        }
      } else {
        console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: No container with "aria-controls"-Id found.');
      }

      if (data.event) {
        data.event.stopPropagation();
      }
      return newVisibilityStatus;
    },
    /**
     * @method Controller.GUI.common.atomToggleChecked
     * @param data {Object}
     * data.trigger = clickedElement
     */
    atomToggleChecked: function (data) {
      var triggeredElement = data.trigger;
      if (!triggeredElement) {
        return;
      }
      var checkedEl = triggeredElement.getAttribute('aria-checked');
      if (checkedEl != null) {
        var newChecked = !JSON.parse(checkedEl);
      } else {
        var newChecked = true;
      }
      triggeredElement.setAttribute('aria-checked', newChecked);
    },
    remove: function (elementAttribute) {
      var elements = Hafas('[data-element="' + elementAttribute + '"]', true);
      for (var i = 0; i < elements.length; i++) {
        elements[i].innerHTML = "";
      }
    },
    // data.trigger: Klasse f?r alle Container, die angeklickt werden k?n (optional)
    // data.source: der angeklickte Container (this) (obligatorisch)
    // data.target: Klasse f?r alle Container, die ge?et/geschlossen werden sollen (optional)
    // data.containerId: Der Container, der aktuell ge?et/geschlossen werden soll (obligatorisch)
    toggle: function (data) {
      if (typeof data.trigger != "undefined") {
        var triggerContainer = document.getElementsByClassName(data.trigger);
      }
      if (typeof data.target != "undefined") {
        var targetContainer = document.getElementsByClassName(data.target);
        for (var i = 0; i < targetContainer.length; i++) {
          targetContainer[i].style.display = 'none';
        }
      }

      if ((typeof data.target != "undefined") && (typeof data.trigger != "undefined")) {
        for (var i = 0; i < targetContainer.length; i++) {
          if (typeof data.trigger != "undefined") {
            triggerContainer[i].removeClassName('js_active');
            triggerContainer[i].removeClassName('js_activeTab');
          }
        }
      }

      var currentContainer = Hafas('#' + data.containerId);
      var currentContainerStyle = currentContainer.style.display;
      if (currentContainerStyle == "block") {
        currentContainer.style.display = 'none';
        data.source.removeClassName('js_active');
        data.source.removeClassName('js_activeTab');
      } else {
        currentContainer.style.display = 'block';
        data.source.addClassName('js_active');
        data.source.addClassName('js_activeTab');
      }
      Hafas.ps.pub('/app/events/resize');
    },
    showCookieHint: function () {
      var targetContainer = Hafas('#HFS_CookieHint');
      var storage = Hafas.Core.newType("hafasStorage");
      var cookieAcceptance = storage.get('cookieAcceptance_' + Hafas.Config.storageId);
      if (cookieAcceptance == null) {
        Hafas.Modules.Render.render({
          file: 'common.base.html',
          target: targetContainer,
          template: 'Common_TplCookieHint',
          model: {}
        },
          function (response) {
            Hafas.Util.gui.setVisibility(targetContainer, true);
          });
      }
    },
    hideCookieHint: function () {
      var targetContainer = Hafas('#HFS_CookieHint');
      Hafas.Util.gui.setVisibility(targetContainer, false);
      var storage = Hafas.Core.newType("hafasStorage");
      storage.set('cookieAcceptance_' + Hafas.Config.storageId, true);
    },
    setApplicationHeader: function (opts) {
      // +++++ /GUI/common/setApplicationHeader +++++
      var $el = Hafas('#HFS_itemNavbarAppContextName', false);
      var headerName = Hafas.Modules.i18n.get(opts.appcontext + '.index.t_N_applicationName');
      setTimeout(function () {
        document.title = headerName + ' - ' + Hafas.Config.client.name;
      }, 200);

      if ($el) {
        $el.innerHTML = headerName
      }
    },
    getLayoutClass: function () {
      // +++++ /GUI/common/getLayoutClass +++++
      var $webappWrap = Hafas('#' + this.webappWrap, false);
      // aktuelle LayoutClass ermitteln
      var _layoutClass = $webappWrap.className.match(/(layout-)([a-zA-Z]*)/g);
      if (_layoutClass) {
        this.layoutClass = _layoutClass[0].split('-')[1];
      } else {
        this.layoutClass = '';
      }
      return this.layoutClass;
    },
    events: {},
    messages: {
      toggleExcerptMessage: function (params) {
        Hafas.ps.pub('/GUI/common/atomToggleContainer', [{
          trigger: params.trigger,
          event: params.event
        }]);
        Hafas.ps.pub('/app/events/resize');
        params.event.stopPropagation();
        // Exzerpt-Text beim Öffnen ausblenden
        var excerptContainer = Hafas("#" + params.excId);
        if (excerptContainer != null) {
          Hafas.Util.gui.toggleVisibility(excerptContainer);
        }
      }
    },
    toggleMobileMenu: function () {
      var nav = Hafas('#HFS_HeaderNav', false);
      if (nav.classList.contains('js_openNav')) {
        Hafas.ps.pub('/GUI/common/hideMobileMenu');
      } else {
        Hafas.ps.pub('/GUI/common/showMobileMenu');
      }

    },
    hideMobileMenu: function() {
      var nav = Hafas('#HFS_HeaderNav', false);
      var menuButton = Hafas("#HFS_MenuButton",false);
      nav.classList.remove('js_openNav');
      menuButton.setAttribute('aria-expanded','false');
      menuButton.classList.remove('js_open');
      Hafas('#HFS_TPCoreForm',false).focus();

      var headerNavItems = Hafas('#HFS_HeaderNav div',true)
      headerNavItems.forEach(function(item){
        item.setAttribute('aria-hidden',true)
      });
    },
    showMobileMenu: function() {
      var nav = Hafas('#HFS_HeaderNav', false);
      var menuButton = Hafas("#HFS_MenuButton",false);
      nav.classList.add('js_openNav');
      menuButton.setAttribute('aria-expanded','true');
      menuButton.classList.add('js_open');

      var headerNavItems = Hafas('#HFS_HeaderNav div',true)
      headerNavItems.forEach(function(item){
        item.setAttribute('aria-hidden',false)
      });
    },
    toggleLanguagesMenu:function (el){

      var container    = el.parentNode;
      var menuList  = container.querySelector('ul');
      var listOptions  = menuList.querySelectorAll('li');

      if(container.classList.contains('js_active')){
        menuList.setAttribute('aria-hidden',"true");
        container.classList.remove('js_active')
      }
      else{
       container.classList.add('js_active');
        menuList.setAttribute('aria-hidden',"false");
       document.addEventListener('click', close );
       document.addEventListener('keyup', close );
       listOptions.forEach(function (item){
         item.addEventListener('keyup',optionsEvents );
       })
      }

    function close(ev){
      if(ev.type=== "click" ){
        var parent = ev.target.parentNode
        if(parent !== container)
          container.classList.remove('js_active')
      }

      if( ev.type === "keyup"){
        var parent = ev.target.parentNode.parentNode.parentNode
        if(parent !== container)
          container.classList.remove('js_active')
      }
    }
    function optionsEvents(ev){
      var parent = ev.target.parentNode
      listOptions.forEach(function (item){
        item.setAttribute('tabindex','-1');
        item.setAttribute('aria-selected',"false");
        item.blur();
      })

      parent.setAttribute('tabindex','0');
      parent.setAttribute('aria-selected',"true")

      }
    }
  },
  overlay: {
    test: function (data) {
      if (data.ev)
        data.ev.preventDefault();

      var model = {
        title: 'Testoverlay',
        msg: 'Das ist ein <strong>Test</strong>. mal sehen was passiert'
      };

      Hafas.Core.newType("HafasOverlay", {
        file: 'common.overlay.html',
        template: 'Overlay_TplTest',
        model: model
      });
    },
    push: function (data) {
      if (data.ev)
        data.ev.preventDefault();
      var model = {
        type: data.type,
        title: data.title,
        msg: data.msg
      };

      Hafas.Core.newType("HafasOverlay", {
        file: 'common.overlay.html',
        template: 'Overlay_TplPush',
        model: model
      });
    }
  },
  calendarExport: {
    currentOverlay: null,
    // show tooltip with all the export options
    showExportOptions: function (data) {
      var _me = this,
        results = this.Controller.TP.instance.getResults(data.connectionType);

      // Tracking
      Hafas.ps.pub('/tracking/event/button-calendar', [{ typ: 'event', key: 'button-calendar' }]);

      if (Hafas.Modules.History)
        Hafas.Modules.History.addSubView("/GUI/calendarExport/closeOptions", "ExportPopup", {});

      if (data.connectionType == 'PT') {
        currConnection = results[data.arrayIdx - 1];
      } else {
        currConnection = results[data.arrayIdx - 1].resolvedConnection;
      }


      var startLoc = currConnection.secL[0].dep;
      var destLoc = currConnection.secL[currConnection.secL.length - 1].arr;

      var startTime = Hafas.Core.newType('hafasTime', {
        date: currConnection.date,
        time: startLoc.dTimeS
      }).jsDate;
      var tmpDateSString = startTime.toISOString().replace(/-|:|\./g, '');
      var tmpDateSPart = tmpDateSString.substr(0, (tmpDateSString.length - 4));
      tmpDateSPart = tmpDateSPart + 'Z';

      var destTime = Hafas.Core.newType('hafasTime', {
        date: currConnection.date,
        time: destLoc.aTimeS
      }).jsDate;
      var tmpDateEString = destTime.toISOString().replace(/-|:|\./g, '');
      var tmpDateEPart = tmpDateEString.substr(0, (tmpDateEString.length - 4));
      tmpDateEPart = tmpDateEPart + 'Z';

      // journey details
      var calTitle = '';
      var calText = '';

      Hafas.Modules.Render.render(
        {
          template: 'TP_AtomCalendarExportTitle',
          model: currConnection
        },
        function (html) {
          calTitle = html.replace(/\n/g, '');


          Hafas.Modules.Render.render(
            {
              template: 'TP_AtomCalendarExportText',
              model: currConnection
            },
            function (html) {
              calText = html.replace(/\n/g, '');


              var encodedDescription = encodeURIComponent(calText);
              encodedDescription = encodedDescription.replace(/%40%40%40/g, "%0A");

              var paramObj = {
                title: calTitle,
                location: startLoc.locResolved.name,
                date_start_z: tmpDateSPart,
                date_end_z: tmpDateEPart,
                description: encodedDescription
              };

              var calendarOptions = [
                {
                  icnClass: 'haf_ic_google',
                  format: 'google',
                  baseUrl: 'https://www.google.com/calendar/render?action=TEMPLATE&',
                  label: Hafas.Modules.i18n.get('TP.calendarExport.t_N_ExportTo_google')
                },
                {
                  icnClass: 'haf_ic_outlook',
                  format: 'outlook',
                  baseUrl: 'https://bay02.calendar.live.com/calendar/calendar.aspx?rru=addevent&',
                  label: Hafas.Modules.i18n.get('TP.calendarExport.t_N_ExportTo_outlook')
                },
                {
                  icnClass: 'haf_ic_yahoo',
                  format: 'yahoo',
                  baseUrl: 'http://calendar.yahoo.com/?view=d&v=60&type=20&',
                  label: Hafas.Modules.i18n.get('TP.calendarExport.t_N_ExportTo_yahoo')
                },
                {
                  format: 'ics',
                  baseUrl: '',
                  label: Hafas.Modules.i18n.get('TP.calendarExport.t_N_ExportTo_ics')
                }
              ];

              var calFormats = [];
              for (var c = 0; c < calendarOptions.length; c++) {
                if (typeof Hafas.Config.Export.Calendar[calendarOptions[c].format] != 'undefined' && ((Hafas.Config.Export.Calendar[calendarOptions[c].format] == true) || (typeof Hafas.Config.Export.Calendar[calendarOptions[c].format].use != 'undefined' && Hafas.Config.Export.Calendar[calendarOptions[c].format].use))) {
                  calFormats.push(calendarOptions[c]);
                }
              }
              for (var i = 0; i < calFormats.length; i++) {
                var exportUrl = calFormats[i].baseUrl;

                if (calFormats[i].format == 'google') {
                  exportUrl += 'text=' + encodeURIComponent(paramObj.title)
                    + '&location=' + encodeURIComponent(paramObj.location)
                    + '&details=' + paramObj.description
                    + '&dates=' + paramObj.date_start_z + '/' + paramObj.date_end_z;
                } else if (calFormats[i].format == 'yahoo') {
                  exportUrl += 'title=' + encodeURIComponent(paramObj.title)
                    + '&in_loc=' + encodeURIComponent(paramObj.location)
                    + '&desc=' + paramObj.description
                    + '&st=' + paramObj.date_start_z;
                } else if (calFormats[i].format == 'outlook') {
                  exportUrl += 'summary=' + encodeURIComponent(paramObj.title)
                    + '&location=' + encodeURIComponent(paramObj.location)
                    + '&description=' + paramObj.description
                    + '&dtstart=' + paramObj.date_start_z
                    + '&dtend=' + paramObj.date_end_z;
                } else {
                  var tmpDesc = paramObj.description;
                  calFormats[i].title = paramObj.title;
                  calFormats[i].date_start_z = paramObj.date_start_z;
                  calFormats[i].date_end_z = paramObj.date_end_z;
                  calFormats[i].description = tmpDesc;
                  /*exportUrl += 'title='+encodeURIComponent(paramObj.title)
                   + '&date_start_z='+paramObj.date_start_z
                   + '&date_end_z='+paramObj.date_end_z
                   + '&description='+tmpDesc;*/
                }

                calFormats[i].href = exportUrl;

              }

              var outputHtml = '';

              Hafas.Modules.Render.render(
                {
                  template: 'TP_AtomCalendarExportExportList',
                  model: { formats: calFormats }
                },
                function (html) {
                  // generate output-HTML for overlay
                  outputHtml = html.replace(/\n/g, '');

                  _me.Controller.GUI.calendarExport.currentOverlay = Hafas.Core.newType("HafasOverlay", {
                    app: _me,
                    outputHTML: outputHtml,
                    title: Hafas.Modules.i18n.get('common.label.t_N_Export'),
                    cssClass: 'hfs_calendarExportOverlay',
                    onClose: function () {
                      if (Hafas.Modules.History)
                        Hafas.Modules.History.removeCurrentStep("ExportPopup");
                    }
                  });
                }
              );
            }
          );
        }
      );
    },
    closeExportOptions: function () {
      if (this.Controller.GUI.calendarExport.currentOverlay != null) {
        this.Controller.GUI.calendarExport.currentOverlay.close();
      }
      this.Controller.GUI.calendarExport.currentOverlay = null;
    }
  },
  smallAlert: {
    show: function (text, button) {

      var alert = Hafas("#HFS_SmallAlert");
      alert.innerHTML = "<div class='lyr_text'>" + text + "</div>";
      alert.addClassName("lyr_show");

      setTimeout(function () {
        alert.removeClassName("lyr_show");
      }, 2000);
    }
  }
};
